import '../../scss/layout.global.scss'

import { TallinkSiljaHeader } from '@tallink/components-lib'
import PropTypes from 'prop-types'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { getDigiData } from '../../selectors/selectors'
import Footer from '../common/Footer'
import s from './Layout.module.scss'

export default function Layout({ children, pageTitle }) {
  const { t } = useTranslation()

  const digiData = useSelector(getDigiData)
  const country = digiData?.website?.country || 'fi'

  return (
    <>
      <Helmet titleTemplate="%s | Tallink Silja">
        <meta charSet="utf-8" />
        <title>{pageTitle}</title>
      </Helmet>
      <div className={s['page-layout']}>
        <TallinkSiljaHeader
          accessibilityUrl={country !== 'xz' ? t('accessibility.url') : null}
          ariaLabelTranslation={t('accessibility')}
        />
        <main className={s['page-content']}>{children}</main>
        <div className={s['footer-wrapper']}>
          <Footer />
        </div>
      </div>
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node,
  pageTitle: PropTypes.string.isRequired
}
